import React, { Component } from 'react';
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon, } from "@fortawesome/react-fontawesome";
import '../css/qtyEdit.css';

export class POItemInfo extends Component {

    constructor(props) {
        super(props);
        this.processOptionsString = this.processOptionsString.bind(this);
        this.validateQuantityChange = this.validateQuantityChange.bind(this);
        this.validateTypeInput = this.validateTypeInput.bind(this);
    }

    processOptionsString(options) {
        var optionsArray = [];
        if (options) {
            var optionsDict = JSON.parse(options);
            for (var key in optionsDict) {
                var optionsInfo = optionsDict[key];
                optionsInfo.fieldId = key;
                optionsArray.push(optionsInfo);
            }
            console.log("OPTIONS ARRAY", optionsArray);
        }
        return optionsArray;
    }

    validateQuantityChange(value, maxQty) {
        var item = this.props.itemInfo;
        var newQty = item.quantityPicked + value;
        if (newQty < 0 || newQty > maxQty) {
            if (newQty > maxQty) {
                alert("You do not need any more of this item. You only need " + maxQty);
                document.getElementById('qty-edit-input').focus();
            }
            return;
        }
        item.quantityPicked = newQty;
        this.props.updateRecievedQty(item)
    }

    validateTypeInput(e, maxQty) {
        var newQty = e.target.value;
        if (!newQty) {
            this.setState({
                qtyDisplay: ''
            });
            document.getElementById('qty-edit-input').focus();
            return;
        }
        else {
            newQty = parseInt(newQty);
        }
        if (newQty > maxQty) {
            alert("You must enter a number between 0 and " + maxQty);
            document.getElementById('qty-edit-input').focus();
            return;
        }
        if (this.props.useBins) {
            var usedBin = this.state.usedBin;
            var qtyDifference = newQty - usedBin.qty;
        }
        else {
            var item = this.props.itemInfo;
            var qtyDifference = newQty - item.quantityPicked;
        }
        this.validateQuantityChange(qtyDifference, maxQty);
    }

    render() {
        var itemInfo = this.props.itemInfo;
        var maxQty = itemInfo.quantity;
        var options = this.processOptionsString(itemInfo.options);
        var itemClassName = "nametag-line-summary";
        if (itemInfo.quantityPicked == itemInfo.quantity) {
            itemClassName += " nametag-fully-received";
        }
        else if (itemInfo.hasWrongItem || itemInfo.missingItem || itemInfo.hasWrongBacking) {
            itemClassName += " nametag-has-issue";
        }
        else if(itemInfo.quantityPicked > 0) {
            itemClassName += " nametag-partially-received";
        }
        return (
            <div className={itemClassName}>
                <h1>{itemInfo.item} {itemInfo.missingItem && <h6 className="error-reason">MISSING ITEM</h6>} {itemInfo.hasWrongItem && <h6 className="error-reason">WRONG ITEM</h6>} {itemInfo.hasWrongBacking && <h6 className="error-reason">WRONG BACKING</h6>}</h1>
                <div>
                    <div>
                        <div class="number">
                            <span>Qty Received:</span>
                            <FontAwesomeIcon className="imageIcon" onClick={() => this.validateQuantityChange(-1, maxQty)} size="lg" icon={faMinus} />
                            <input id="qty-edit-input" onChange={(e) => { this.validateTypeInput(e, maxQty) }} type="number" value={itemInfo.quantityPicked} min="0" max={maxQty} />
                            <FontAwesomeIcon className="imageIcon" onClick={() => this.validateQuantityChange(1, maxQty)} size="lg" icon={faPlus} />
                        </div>
                    </div>
                    <h2>Qty Needed: {itemInfo.quantity}</h2>
                </div>
                <div className="nametag-info">
                    {
                        //Loop through the options and display them
                        options.map(function (option, idx) {
                            console.log("OPTION", option);
                            return (
                                <div key={idx} data-field-id={option.fieldId}>
                                    <h3>{option.name} : {option.text}</h3>
                                </div>
                            )
                        })
                    }
                </div>
                {
                    itemInfo.quantity != itemInfo.quantityPicked &&
                    <div error-buttons>
                        {<button className="issue-button" onClick={() => { this.props.handleMissingItems(itemInfo) }}>Didn't Receive</button>}
                        {<button className="issue-button" onClick={() => { this.props.handleWrongItems(itemInfo) }}>Printed Wrong</button>}
                        {<button className="issue-button" onClick={() => { this.props.handleWrongBacking(itemInfo) }}>Wrong Backing</button>}
                    </div>
                }
            </div>
        );
    }
}